import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectComponent } from './multi-select.component';
import { MultiSelectModule } from 'primeng/multiselect';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule
  ],
  declarations: [MultiSelectComponent],
  exports: [MultiSelectComponent],
  
})
export class MSelectModule { }
